export const isIos = () => {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return /iphone|ipad|ipod/.test(userAgent)
}

export const isAndroid = () => {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return /android/.test(userAgent)
}

export const isMobile = () => {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)
}

export const isInStandaloneMode = () =>
  'standalone' in window.navigator && window.navigator.standalone

export const getPlatform = () => (isInStandaloneMode() ? 'PWA' : 'Web')

export const isIosStandaloneMode = () => isIos() && isInStandaloneMode()
